import {
    makeStyles
}

    from '@mui/styles';

export const useSharedStyles = makeStyles(() => ({
    font16500: {
        fontSize: '16px !important',
        fontWeight: '500 !important',
    }

    ,
    font14500: {
        fontSize: '14px',
        fontWeight: 500,
    }

    ,
    font14400: {
        fontSize: '14px',
        fontWeight: 400,
    }

    ,
}));